module.exports = __webpack_public_path__ + "img/my_kyc_ex1.20a384aa.png";